<div class="tw:w-full tw:px-4">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    <div class="tw:flex-1 tw:px-[15px]">

      <placement-search #placementSearch
      [externalView]="true"></placement-search>

    </div>

  </div>
</div>